import { createApp } from 'vue';
import { setupApp } from '../bootstrap';
import CampaignLuckyboxApp from '../vue/views/campaign/luckybox/index.vue';

//
const app = createApp({});
//cpapp.config.globalProperties.$apexcharts = ApexCharts;

// 使用統一配置並掛載應用
setupApp(app)
    .component('campaign-luckybox-app', CampaignLuckyboxApp)
    .mount('#campaign-app');
